/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "discovery";

/** SerializationFormat defines how RPC messages are encoded */
export enum SerializationFormat {
  SERIALIZATION_FORMAT_UNSPECIFIED = 0,
  SERIALIZATION_FORMAT_JSON = 1,
  SERIALIZATION_FORMAT_PROTOBUF = 2,
  UNRECOGNIZED = -1,
}

export function serializationFormatFromJSON(object: any): SerializationFormat {
  switch (object) {
    case 0:
    case "SERIALIZATION_FORMAT_UNSPECIFIED":
      return SerializationFormat.SERIALIZATION_FORMAT_UNSPECIFIED;
    case 1:
    case "SERIALIZATION_FORMAT_JSON":
      return SerializationFormat.SERIALIZATION_FORMAT_JSON;
    case 2:
    case "SERIALIZATION_FORMAT_PROTOBUF":
      return SerializationFormat.SERIALIZATION_FORMAT_PROTOBUF;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SerializationFormat.UNRECOGNIZED;
  }
}

export function serializationFormatToJSON(object: SerializationFormat): string {
  switch (object) {
    case SerializationFormat.SERIALIZATION_FORMAT_UNSPECIFIED:
      return "SERIALIZATION_FORMAT_UNSPECIFIED";
    case SerializationFormat.SERIALIZATION_FORMAT_JSON:
      return "SERIALIZATION_FORMAT_JSON";
    case SerializationFormat.SERIALIZATION_FORMAT_PROTOBUF:
      return "SERIALIZATION_FORMAT_PROTOBUF";
    case SerializationFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RpcFormat defines the format for RPC schema responses */
export enum RpcFormat {
  RPC_FORMAT_UNSPECIFIED = 0,
  /** RPC_FORMAT_PROTO_DESCRIPTOR_SET - Binary FileDescriptorSet */
  RPC_FORMAT_PROTO_DESCRIPTOR_SET = 1,
  /** RPC_FORMAT_JSON_SCHEMA - JSON Schema representation */
  RPC_FORMAT_JSON_SCHEMA = 2,
  UNRECOGNIZED = -1,
}

export function rpcFormatFromJSON(object: any): RpcFormat {
  switch (object) {
    case 0:
    case "RPC_FORMAT_UNSPECIFIED":
      return RpcFormat.RPC_FORMAT_UNSPECIFIED;
    case 1:
    case "RPC_FORMAT_PROTO_DESCRIPTOR_SET":
      return RpcFormat.RPC_FORMAT_PROTO_DESCRIPTOR_SET;
    case 2:
    case "RPC_FORMAT_JSON_SCHEMA":
      return RpcFormat.RPC_FORMAT_JSON_SCHEMA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RpcFormat.UNRECOGNIZED;
  }
}

export function rpcFormatToJSON(object: RpcFormat): string {
  switch (object) {
    case RpcFormat.RPC_FORMAT_UNSPECIFIED:
      return "RPC_FORMAT_UNSPECIFIED";
    case RpcFormat.RPC_FORMAT_PROTO_DESCRIPTOR_SET:
      return "RPC_FORMAT_PROTO_DESCRIPTOR_SET";
    case RpcFormat.RPC_FORMAT_JSON_SCHEMA:
      return "RPC_FORMAT_JSON_SCHEMA";
    case RpcFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** RpcMethod represents a single method within an RPC schema */
export interface RpcMethod {
  /** Method name (e.g., "Ping", "Shutdown", "GetStatus") */
  name: string;
  /**
   * Supported serialization formats for this method
   * If empty, inherits from schema-level formats
   */
  formats: SerializationFormat[];
  /** Optional: fully qualified request message type (e.g., "process.v1.ShutdownRequest") */
  requestType: string;
  /** Optional: fully qualified response message type (e.g., "process.v1.ShutdownResponse") */
  responseType: string;
  /** Optional: method documentation or description */
  description: string;
}

/** RpcSchema represents a versioned collection of RPC methods */
export interface RpcSchema {
  /** Schema name (e.g., "process.v1", "scheduler.v1") */
  name: string;
  /** Methods available in this schema */
  methods: RpcMethod[];
  /**
   * Default serialization formats supported by all methods in this schema
   * Individual methods can override this with their own formats list
   */
  defaultFormats: SerializationFormat[];
  /** Optional: schema version for future evolution */
  schemaVersion: number;
  /** Optional: schema documentation */
  description: string;
}

/**
 * ProcessCapabilities describes what a process can do
 * This is the protobuf representation of the capabilities
 */
export interface ProcessCapabilities {
  /** RPC schemas implemented by this process */
  schemas: RpcSchema[];
  /** Location where this process is running */
  location:
    | ProcessLocation
    | undefined;
  /** Enabled engines/components (for services like Mesh) */
  engines: string[];
}

/**
 * BuildInfo is the STRUCTURED, first-class identity of the binary a process is
 * running — "which build is this?", the single most useful question during an
 * incident (FEATURE-20260709-processstart-build-info). It is a typed message, not
 * extended_metadata string-map fishing: a client consuming a well-structured
 * proto beats parsing an anything-goes map. Every field mirrors a
 * pkg/buildinfo.GetInfo() key (Go) / META-INF/version-details.properties (Scala),
 * so the registry view is uniform across languages. Fields are empty (not
 * "unknown") when a build did not stamp them.
 */
export interface BuildInfo {
  /** release version string */
  version: string;
  /** source repo (e.g. "godev") */
  gitRepo: string;
  /** commit sha the binary was built from */
  gitCommit: string;
  gitBranch: string;
  /** "true" when the tree had uncommitted changes at build */
  gitDirty: string;
  /** when the binary was built */
  buildTimestamp: string;
  buildMachine: string;
  buildUser: string;
  buildIps: string;
  /** language/runtime version (go version, or JVM/Scala on the sync side) */
  goVersion: string;
  /** target OS */
  goos: string;
  /** target arch */
  goarch: string;
  /**
   * The CODEBASE marker: which repo built this binary ("godev", "checkpoint", "sync").
   * Part of the BUILD IDENTITY contract so every client carries it wherever buildInfo
   * goes — DiscoveryResponse.codebaseName predates it and remains, but only travels on
   * full discovery responses; this rides with the build info itself.
   * BUG-20260802-checkpoint-does-not-self-report.
   */
  codebaseName: string;
}

/** ProcessLocation describes where a process is running */
export interface ProcessLocation {
  /** Server hostname */
  server: string;
  /** User the process runs as */
  user: string;
  /** Non-localhost IPv4 addresses */
  ipAddresses: string[];
}

/**
 * DiscoveryResponse contains complete process discovery information.
 * This message is embedded in continuum_rpc.ProcessStartedRequest (field 19)
 * for single-path process registration with the registry.
 * It's also used by process.v1.Describe RPC for ad-hoc queries.
 */
export interface DiscoveryResponse {
  /** RequestID from the DiscoveryRequest that triggered this response */
  requestId: string;
  /** ProcessUid uniquely identifies this process instance (ULID/UUID) */
  processUid: string;
  /** Unix process ID */
  unixPid: number;
  /** AppName is the application name (e.g., "worker", "mesh") */
  appName: string;
  /** MailboxAddress for sending messages to this process */
  mailboxAddress: string;
  /** ServiceName identifies the type of service */
  serviceName: string;
  /**
   * CodebaseName identifies which codebase/repository this process was built from
   * MANDATORY field (e.g., "godev", "continuum")
   */
  codebaseName: string;
  /** Timestamp when the response was created (Unix epoch milliseconds) */
  timestamp: string;
  /** Capabilities with rich schema information */
  capabilities:
    | ProcessCapabilities
    | undefined;
  /** Essential process metadata */
  metadata: { [key: string]: string };
  /**
   * Extended build metadata (when requested)
   * Always includes "programming_language" key (e.g., "go", "scala")
   * Also includes: build_timestamp, build_machine, build_user, etc.
   *
   * DEPRECATED for build info: the structured build_info field below is the
   * first-class form. extended_metadata is still populated with the same
   * build_* keys during the transition (dual-publish) so existing map consumers
   * keep working; new consumers should read build_info.
   */
  extendedMetadata: { [key: string]: string };
  /** Service discovery mapping */
  serviceDiscoveryMapping: { [key: string]: string };
  /**
   * Structured, first-class binary identity (FEATURE-20260709). The typed form
   * of the build_* keys also carried in extended_metadata. Absent when the
   * process reported no build info. Rides embedded in
   * continuum_rpc.ProcessStartedRequest (field 19) so it reaches the registry at
   * registration, and is returned by process.v1.Describe for ad-hoc queries.
   */
  buildInfo: BuildInfo | undefined;
}

export interface DiscoveryResponse_MetadataEntry {
  key: string;
  value: string;
}

export interface DiscoveryResponse_ExtendedMetadataEntry {
  key: string;
  value: string;
}

export interface DiscoveryResponse_ServiceDiscoveryMappingEntry {
  key: string;
  value: string;
}

/** DiscoveryQuery contains filters for finding processes */
export interface DiscoveryQuery {
  /** Filter by RPC schema names */
  implementsRpc: string[];
  /** Filter by app name (supports wildcards) */
  appName: string;
  /** Filter by service name (supports wildcards) */
  serviceName: string;
  /** Filter by location */
  location:
    | LocationQuery
    | undefined;
  /** Request extended metadata in responses */
  includeExtendedMetadata: boolean;
  /**
   * Request detailed schema information (methods, formats)
   * When false, only schema names are returned for efficiency
   */
  includeSchemaDetails: boolean;
}

/** LocationQuery filters by deployment location */
export interface LocationQuery {
  server: string;
  user: string;
  userServer: string;
}

/**
 * DiscoveryRequest for finding processes via NATS broadcast.
 * Used only by process.v1.Describe RPC for ad-hoc queries, not for registry startup.
 * Registry recovery now uses database query instead of discovery broadcast.
 */
export interface DiscoveryRequest {
  requestId: string;
  replySuffix: string;
  timestamp: string;
  query: DiscoveryQuery | undefined;
}

/** RpcListRequest requests all available RPC interfaces */
export interface RpcListRequest {
}

/** RpcInfo describes a registered RPC interface */
export interface RpcInfo {
  /** e.g., "process.v1" */
  name: string;
  /** Method names */
  methods: string[];
  /** Supported serialization formats */
  formats: SerializationFormat[];
  /** RPC interface documentation */
  description: string;
}

/** RpcListResponse returns all registered RPC interfaces */
export interface RpcListResponse {
  rpcs: RpcInfo[];
}

/** RpcGetRequest requests a specific RPC interface definition */
export interface RpcGetRequest {
  /** e.g., "process.v1", "auth.v2" */
  name: string;
  /** Desired output format */
  format: RpcFormat;
}

/** RpcGetResponse returns RPC interface definition in requested format */
export interface RpcGetResponse {
  /** RPC name from request */
  name: string;
  /** Format of the response */
  format: RpcFormat;
  /** Binary proto descriptor or JSON bytes */
  data: Uint8Array;
  /** Error if RPC not found or format unavailable */
  errorMessage: string;
  /** Metadata about the RPC interface */
  messageCount: number;
  /** Number of enums */
  enumCount: number;
  /** Proto file dependencies */
  dependencies: string[];
}

function createBaseRpcMethod(): RpcMethod {
  return { name: "", formats: [], requestType: "", responseType: "", description: "" };
}

export const RpcMethod = {
  encode(message: RpcMethod, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    writer.uint32(18).fork();
    for (const v of message.formats) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.requestType !== "") {
      writer.uint32(26).string(message.requestType);
    }
    if (message.responseType !== "") {
      writer.uint32(34).string(message.responseType);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcMethod {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcMethod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag === 16) {
            message.formats.push(reader.int32() as any);

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.formats.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.requestType = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.responseType = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcMethod {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      formats: globalThis.Array.isArray(object?.formats)
        ? object.formats.map((e: any) => serializationFormatFromJSON(e))
        : [],
      requestType: isSet(object.requestType) ? globalThis.String(object.requestType) : "",
      responseType: isSet(object.responseType) ? globalThis.String(object.responseType) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: RpcMethod): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.formats?.length) {
      obj.formats = message.formats.map((e) => serializationFormatToJSON(e));
    }
    if (message.requestType !== "") {
      obj.requestType = message.requestType;
    }
    if (message.responseType !== "") {
      obj.responseType = message.responseType;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcMethod>, I>>(base?: I): RpcMethod {
    return RpcMethod.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcMethod>, I>>(object: I): RpcMethod {
    const message = createBaseRpcMethod();
    message.name = object.name ?? "";
    message.formats = object.formats?.map((e) => e) || [];
    message.requestType = object.requestType ?? "";
    message.responseType = object.responseType ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseRpcSchema(): RpcSchema {
  return { name: "", methods: [], defaultFormats: [], schemaVersion: 0, description: "" };
}

export const RpcSchema = {
  encode(message: RpcSchema, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.methods) {
      RpcMethod.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    writer.uint32(26).fork();
    for (const v of message.defaultFormats) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.schemaVersion !== 0) {
      writer.uint32(32).int32(message.schemaVersion);
    }
    if (message.description !== "") {
      writer.uint32(42).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcSchema {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcSchema();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.methods.push(RpcMethod.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag === 24) {
            message.defaultFormats.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.defaultFormats.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.schemaVersion = reader.int32();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcSchema {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      methods: globalThis.Array.isArray(object?.methods) ? object.methods.map((e: any) => RpcMethod.fromJSON(e)) : [],
      defaultFormats: globalThis.Array.isArray(object?.defaultFormats)
        ? object.defaultFormats.map((e: any) => serializationFormatFromJSON(e))
        : [],
      schemaVersion: isSet(object.schemaVersion) ? globalThis.Number(object.schemaVersion) : 0,
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: RpcSchema): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.methods?.length) {
      obj.methods = message.methods.map((e) => RpcMethod.toJSON(e));
    }
    if (message.defaultFormats?.length) {
      obj.defaultFormats = message.defaultFormats.map((e) => serializationFormatToJSON(e));
    }
    if (message.schemaVersion !== 0) {
      obj.schemaVersion = Math.round(message.schemaVersion);
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcSchema>, I>>(base?: I): RpcSchema {
    return RpcSchema.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcSchema>, I>>(object: I): RpcSchema {
    const message = createBaseRpcSchema();
    message.name = object.name ?? "";
    message.methods = object.methods?.map((e) => RpcMethod.fromPartial(e)) || [];
    message.defaultFormats = object.defaultFormats?.map((e) => e) || [];
    message.schemaVersion = object.schemaVersion ?? 0;
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseProcessCapabilities(): ProcessCapabilities {
  return { schemas: [], location: undefined, engines: [] };
}

export const ProcessCapabilities = {
  encode(message: ProcessCapabilities, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.schemas) {
      RpcSchema.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.location !== undefined) {
      ProcessLocation.encode(message.location, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.engines) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessCapabilities {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessCapabilities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.schemas.push(RpcSchema.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.location = ProcessLocation.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.engines.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessCapabilities {
    return {
      schemas: globalThis.Array.isArray(object?.schemas) ? object.schemas.map((e: any) => RpcSchema.fromJSON(e)) : [],
      location: isSet(object.location) ? ProcessLocation.fromJSON(object.location) : undefined,
      engines: globalThis.Array.isArray(object?.engines) ? object.engines.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: ProcessCapabilities): unknown {
    const obj: any = {};
    if (message.schemas?.length) {
      obj.schemas = message.schemas.map((e) => RpcSchema.toJSON(e));
    }
    if (message.location !== undefined) {
      obj.location = ProcessLocation.toJSON(message.location);
    }
    if (message.engines?.length) {
      obj.engines = message.engines;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcessCapabilities>, I>>(base?: I): ProcessCapabilities {
    return ProcessCapabilities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcessCapabilities>, I>>(object: I): ProcessCapabilities {
    const message = createBaseProcessCapabilities();
    message.schemas = object.schemas?.map((e) => RpcSchema.fromPartial(e)) || [];
    message.location = (object.location !== undefined && object.location !== null)
      ? ProcessLocation.fromPartial(object.location)
      : undefined;
    message.engines = object.engines?.map((e) => e) || [];
    return message;
  },
};

function createBaseBuildInfo(): BuildInfo {
  return {
    version: "",
    gitRepo: "",
    gitCommit: "",
    gitBranch: "",
    gitDirty: "",
    buildTimestamp: "",
    buildMachine: "",
    buildUser: "",
    buildIps: "",
    goVersion: "",
    goos: "",
    goarch: "",
    codebaseName: "",
  };
}

export const BuildInfo = {
  encode(message: BuildInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.version !== "") {
      writer.uint32(10).string(message.version);
    }
    if (message.gitRepo !== "") {
      writer.uint32(18).string(message.gitRepo);
    }
    if (message.gitCommit !== "") {
      writer.uint32(26).string(message.gitCommit);
    }
    if (message.gitBranch !== "") {
      writer.uint32(34).string(message.gitBranch);
    }
    if (message.gitDirty !== "") {
      writer.uint32(42).string(message.gitDirty);
    }
    if (message.buildTimestamp !== "") {
      writer.uint32(50).string(message.buildTimestamp);
    }
    if (message.buildMachine !== "") {
      writer.uint32(58).string(message.buildMachine);
    }
    if (message.buildUser !== "") {
      writer.uint32(66).string(message.buildUser);
    }
    if (message.buildIps !== "") {
      writer.uint32(74).string(message.buildIps);
    }
    if (message.goVersion !== "") {
      writer.uint32(82).string(message.goVersion);
    }
    if (message.goos !== "") {
      writer.uint32(90).string(message.goos);
    }
    if (message.goarch !== "") {
      writer.uint32(98).string(message.goarch);
    }
    if (message.codebaseName !== "") {
      writer.uint32(106).string(message.codebaseName);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BuildInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBuildInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.version = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.gitRepo = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.gitCommit = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.gitBranch = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.gitDirty = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.buildTimestamp = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.buildMachine = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.buildUser = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.buildIps = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.goVersion = reader.string();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.goos = reader.string();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.goarch = reader.string();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.codebaseName = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BuildInfo {
    return {
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      gitRepo: isSet(object.gitRepo) ? globalThis.String(object.gitRepo) : "",
      gitCommit: isSet(object.gitCommit) ? globalThis.String(object.gitCommit) : "",
      gitBranch: isSet(object.gitBranch) ? globalThis.String(object.gitBranch) : "",
      gitDirty: isSet(object.gitDirty) ? globalThis.String(object.gitDirty) : "",
      buildTimestamp: isSet(object.buildTimestamp) ? globalThis.String(object.buildTimestamp) : "",
      buildMachine: isSet(object.buildMachine) ? globalThis.String(object.buildMachine) : "",
      buildUser: isSet(object.buildUser) ? globalThis.String(object.buildUser) : "",
      buildIps: isSet(object.buildIps) ? globalThis.String(object.buildIps) : "",
      goVersion: isSet(object.goVersion) ? globalThis.String(object.goVersion) : "",
      goos: isSet(object.goos) ? globalThis.String(object.goos) : "",
      goarch: isSet(object.goarch) ? globalThis.String(object.goarch) : "",
      codebaseName: isSet(object.codebaseName) ? globalThis.String(object.codebaseName) : "",
    };
  },

  toJSON(message: BuildInfo): unknown {
    const obj: any = {};
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.gitRepo !== "") {
      obj.gitRepo = message.gitRepo;
    }
    if (message.gitCommit !== "") {
      obj.gitCommit = message.gitCommit;
    }
    if (message.gitBranch !== "") {
      obj.gitBranch = message.gitBranch;
    }
    if (message.gitDirty !== "") {
      obj.gitDirty = message.gitDirty;
    }
    if (message.buildTimestamp !== "") {
      obj.buildTimestamp = message.buildTimestamp;
    }
    if (message.buildMachine !== "") {
      obj.buildMachine = message.buildMachine;
    }
    if (message.buildUser !== "") {
      obj.buildUser = message.buildUser;
    }
    if (message.buildIps !== "") {
      obj.buildIps = message.buildIps;
    }
    if (message.goVersion !== "") {
      obj.goVersion = message.goVersion;
    }
    if (message.goos !== "") {
      obj.goos = message.goos;
    }
    if (message.goarch !== "") {
      obj.goarch = message.goarch;
    }
    if (message.codebaseName !== "") {
      obj.codebaseName = message.codebaseName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BuildInfo>, I>>(base?: I): BuildInfo {
    return BuildInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BuildInfo>, I>>(object: I): BuildInfo {
    const message = createBaseBuildInfo();
    message.version = object.version ?? "";
    message.gitRepo = object.gitRepo ?? "";
    message.gitCommit = object.gitCommit ?? "";
    message.gitBranch = object.gitBranch ?? "";
    message.gitDirty = object.gitDirty ?? "";
    message.buildTimestamp = object.buildTimestamp ?? "";
    message.buildMachine = object.buildMachine ?? "";
    message.buildUser = object.buildUser ?? "";
    message.buildIps = object.buildIps ?? "";
    message.goVersion = object.goVersion ?? "";
    message.goos = object.goos ?? "";
    message.goarch = object.goarch ?? "";
    message.codebaseName = object.codebaseName ?? "";
    return message;
  },
};

function createBaseProcessLocation(): ProcessLocation {
  return { server: "", user: "", ipAddresses: [] };
}

export const ProcessLocation = {
  encode(message: ProcessLocation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.server !== "") {
      writer.uint32(10).string(message.server);
    }
    if (message.user !== "") {
      writer.uint32(18).string(message.user);
    }
    for (const v of message.ipAddresses) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProcessLocation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.server = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.ipAddresses.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessLocation {
    return {
      server: isSet(object.server) ? globalThis.String(object.server) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      ipAddresses: globalThis.Array.isArray(object?.ipAddresses)
        ? object.ipAddresses.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ProcessLocation): unknown {
    const obj: any = {};
    if (message.server !== "") {
      obj.server = message.server;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.ipAddresses?.length) {
      obj.ipAddresses = message.ipAddresses;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProcessLocation>, I>>(base?: I): ProcessLocation {
    return ProcessLocation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProcessLocation>, I>>(object: I): ProcessLocation {
    const message = createBaseProcessLocation();
    message.server = object.server ?? "";
    message.user = object.user ?? "";
    message.ipAddresses = object.ipAddresses?.map((e) => e) || [];
    return message;
  },
};

function createBaseDiscoveryResponse(): DiscoveryResponse {
  return {
    requestId: "",
    processUid: "",
    unixPid: 0,
    appName: "",
    mailboxAddress: "",
    serviceName: "",
    codebaseName: "",
    timestamp: "0",
    capabilities: undefined,
    metadata: {},
    extendedMetadata: {},
    serviceDiscoveryMapping: {},
    buildInfo: undefined,
  };
}

export const DiscoveryResponse = {
  encode(message: DiscoveryResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.processUid !== "") {
      writer.uint32(18).string(message.processUid);
    }
    if (message.unixPid !== 0) {
      writer.uint32(24).int32(message.unixPid);
    }
    if (message.appName !== "") {
      writer.uint32(34).string(message.appName);
    }
    if (message.mailboxAddress !== "") {
      writer.uint32(42).string(message.mailboxAddress);
    }
    if (message.serviceName !== "") {
      writer.uint32(50).string(message.serviceName);
    }
    if (message.codebaseName !== "") {
      writer.uint32(58).string(message.codebaseName);
    }
    if (message.timestamp !== "0") {
      writer.uint32(64).int64(message.timestamp);
    }
    if (message.capabilities !== undefined) {
      ProcessCapabilities.encode(message.capabilities, writer.uint32(74).fork()).ldelim();
    }
    Object.entries(message.metadata).forEach(([key, value]) => {
      DiscoveryResponse_MetadataEntry.encode({ key: key as any, value }, writer.uint32(82).fork()).ldelim();
    });
    Object.entries(message.extendedMetadata).forEach(([key, value]) => {
      DiscoveryResponse_ExtendedMetadataEntry.encode({ key: key as any, value }, writer.uint32(90).fork()).ldelim();
    });
    Object.entries(message.serviceDiscoveryMapping).forEach(([key, value]) => {
      DiscoveryResponse_ServiceDiscoveryMappingEntry.encode({ key: key as any, value }, writer.uint32(98).fork())
        .ldelim();
    });
    if (message.buildInfo !== undefined) {
      BuildInfo.encode(message.buildInfo, writer.uint32(106).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.processUid = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.unixPid = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.appName = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.mailboxAddress = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.serviceName = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.codebaseName = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.timestamp = longToString(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.capabilities = ProcessCapabilities.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          const entry10 = DiscoveryResponse_MetadataEntry.decode(reader, reader.uint32());
          if (entry10.value !== undefined) {
            message.metadata[entry10.key] = entry10.value;
          }
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          const entry11 = DiscoveryResponse_ExtendedMetadataEntry.decode(reader, reader.uint32());
          if (entry11.value !== undefined) {
            message.extendedMetadata[entry11.key] = entry11.value;
          }
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          const entry12 = DiscoveryResponse_ServiceDiscoveryMappingEntry.decode(reader, reader.uint32());
          if (entry12.value !== undefined) {
            message.serviceDiscoveryMapping[entry12.key] = entry12.value;
          }
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.buildInfo = BuildInfo.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryResponse {
    return {
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      processUid: isSet(object.processUid) ? globalThis.String(object.processUid) : "",
      unixPid: isSet(object.unixPid) ? globalThis.Number(object.unixPid) : 0,
      appName: isSet(object.appName) ? globalThis.String(object.appName) : "",
      mailboxAddress: isSet(object.mailboxAddress) ? globalThis.String(object.mailboxAddress) : "",
      serviceName: isSet(object.serviceName) ? globalThis.String(object.serviceName) : "",
      codebaseName: isSet(object.codebaseName) ? globalThis.String(object.codebaseName) : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : "0",
      capabilities: isSet(object.capabilities) ? ProcessCapabilities.fromJSON(object.capabilities) : undefined,
      metadata: isObject(object.metadata)
        ? Object.entries(object.metadata).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      extendedMetadata: isObject(object.extendedMetadata)
        ? Object.entries(object.extendedMetadata).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      serviceDiscoveryMapping: isObject(object.serviceDiscoveryMapping)
        ? Object.entries(object.serviceDiscoveryMapping).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      buildInfo: isSet(object.buildInfo) ? BuildInfo.fromJSON(object.buildInfo) : undefined,
    };
  },

  toJSON(message: DiscoveryResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.processUid !== "") {
      obj.processUid = message.processUid;
    }
    if (message.unixPid !== 0) {
      obj.unixPid = Math.round(message.unixPid);
    }
    if (message.appName !== "") {
      obj.appName = message.appName;
    }
    if (message.mailboxAddress !== "") {
      obj.mailboxAddress = message.mailboxAddress;
    }
    if (message.serviceName !== "") {
      obj.serviceName = message.serviceName;
    }
    if (message.codebaseName !== "") {
      obj.codebaseName = message.codebaseName;
    }
    if (message.timestamp !== "0") {
      obj.timestamp = message.timestamp;
    }
    if (message.capabilities !== undefined) {
      obj.capabilities = ProcessCapabilities.toJSON(message.capabilities);
    }
    if (message.metadata) {
      const entries = Object.entries(message.metadata);
      if (entries.length > 0) {
        obj.metadata = {};
        entries.forEach(([k, v]) => {
          obj.metadata[k] = v;
        });
      }
    }
    if (message.extendedMetadata) {
      const entries = Object.entries(message.extendedMetadata);
      if (entries.length > 0) {
        obj.extendedMetadata = {};
        entries.forEach(([k, v]) => {
          obj.extendedMetadata[k] = v;
        });
      }
    }
    if (message.serviceDiscoveryMapping) {
      const entries = Object.entries(message.serviceDiscoveryMapping);
      if (entries.length > 0) {
        obj.serviceDiscoveryMapping = {};
        entries.forEach(([k, v]) => {
          obj.serviceDiscoveryMapping[k] = v;
        });
      }
    }
    if (message.buildInfo !== undefined) {
      obj.buildInfo = BuildInfo.toJSON(message.buildInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryResponse>, I>>(base?: I): DiscoveryResponse {
    return DiscoveryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryResponse>, I>>(object: I): DiscoveryResponse {
    const message = createBaseDiscoveryResponse();
    message.requestId = object.requestId ?? "";
    message.processUid = object.processUid ?? "";
    message.unixPid = object.unixPid ?? 0;
    message.appName = object.appName ?? "";
    message.mailboxAddress = object.mailboxAddress ?? "";
    message.serviceName = object.serviceName ?? "";
    message.codebaseName = object.codebaseName ?? "";
    message.timestamp = object.timestamp ?? "0";
    message.capabilities = (object.capabilities !== undefined && object.capabilities !== null)
      ? ProcessCapabilities.fromPartial(object.capabilities)
      : undefined;
    message.metadata = Object.entries(object.metadata ?? {}).reduce<{ [key: string]: string }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    message.extendedMetadata = Object.entries(object.extendedMetadata ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.serviceDiscoveryMapping = Object.entries(object.serviceDiscoveryMapping ?? {}).reduce<
      { [key: string]: string }
    >((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value);
      }
      return acc;
    }, {});
    message.buildInfo = (object.buildInfo !== undefined && object.buildInfo !== null)
      ? BuildInfo.fromPartial(object.buildInfo)
      : undefined;
    return message;
  },
};

function createBaseDiscoveryResponse_MetadataEntry(): DiscoveryResponse_MetadataEntry {
  return { key: "", value: "" };
}

export const DiscoveryResponse_MetadataEntry = {
  encode(message: DiscoveryResponse_MetadataEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryResponse_MetadataEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryResponse_MetadataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryResponse_MetadataEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: DiscoveryResponse_MetadataEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryResponse_MetadataEntry>, I>>(base?: I): DiscoveryResponse_MetadataEntry {
    return DiscoveryResponse_MetadataEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryResponse_MetadataEntry>, I>>(
    object: I,
  ): DiscoveryResponse_MetadataEntry {
    const message = createBaseDiscoveryResponse_MetadataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseDiscoveryResponse_ExtendedMetadataEntry(): DiscoveryResponse_ExtendedMetadataEntry {
  return { key: "", value: "" };
}

export const DiscoveryResponse_ExtendedMetadataEntry = {
  encode(message: DiscoveryResponse_ExtendedMetadataEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryResponse_ExtendedMetadataEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryResponse_ExtendedMetadataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryResponse_ExtendedMetadataEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: DiscoveryResponse_ExtendedMetadataEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryResponse_ExtendedMetadataEntry>, I>>(
    base?: I,
  ): DiscoveryResponse_ExtendedMetadataEntry {
    return DiscoveryResponse_ExtendedMetadataEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryResponse_ExtendedMetadataEntry>, I>>(
    object: I,
  ): DiscoveryResponse_ExtendedMetadataEntry {
    const message = createBaseDiscoveryResponse_ExtendedMetadataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseDiscoveryResponse_ServiceDiscoveryMappingEntry(): DiscoveryResponse_ServiceDiscoveryMappingEntry {
  return { key: "", value: "" };
}

export const DiscoveryResponse_ServiceDiscoveryMappingEntry = {
  encode(
    message: DiscoveryResponse_ServiceDiscoveryMappingEntry,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryResponse_ServiceDiscoveryMappingEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryResponse_ServiceDiscoveryMappingEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryResponse_ServiceDiscoveryMappingEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: DiscoveryResponse_ServiceDiscoveryMappingEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryResponse_ServiceDiscoveryMappingEntry>, I>>(
    base?: I,
  ): DiscoveryResponse_ServiceDiscoveryMappingEntry {
    return DiscoveryResponse_ServiceDiscoveryMappingEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryResponse_ServiceDiscoveryMappingEntry>, I>>(
    object: I,
  ): DiscoveryResponse_ServiceDiscoveryMappingEntry {
    const message = createBaseDiscoveryResponse_ServiceDiscoveryMappingEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseDiscoveryQuery(): DiscoveryQuery {
  return {
    implementsRpc: [],
    appName: "",
    serviceName: "",
    location: undefined,
    includeExtendedMetadata: false,
    includeSchemaDetails: false,
  };
}

export const DiscoveryQuery = {
  encode(message: DiscoveryQuery, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.implementsRpc) {
      writer.uint32(10).string(v!);
    }
    if (message.appName !== "") {
      writer.uint32(18).string(message.appName);
    }
    if (message.serviceName !== "") {
      writer.uint32(26).string(message.serviceName);
    }
    if (message.location !== undefined) {
      LocationQuery.encode(message.location, writer.uint32(34).fork()).ldelim();
    }
    if (message.includeExtendedMetadata === true) {
      writer.uint32(40).bool(message.includeExtendedMetadata);
    }
    if (message.includeSchemaDetails === true) {
      writer.uint32(48).bool(message.includeSchemaDetails);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryQuery {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.implementsRpc.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.appName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.serviceName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.location = LocationQuery.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.includeExtendedMetadata = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.includeSchemaDetails = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryQuery {
    return {
      implementsRpc: globalThis.Array.isArray(object?.implementsRpc)
        ? object.implementsRpc.map((e: any) => globalThis.String(e))
        : [],
      appName: isSet(object.appName) ? globalThis.String(object.appName) : "",
      serviceName: isSet(object.serviceName) ? globalThis.String(object.serviceName) : "",
      location: isSet(object.location) ? LocationQuery.fromJSON(object.location) : undefined,
      includeExtendedMetadata: isSet(object.includeExtendedMetadata)
        ? globalThis.Boolean(object.includeExtendedMetadata)
        : false,
      includeSchemaDetails: isSet(object.includeSchemaDetails)
        ? globalThis.Boolean(object.includeSchemaDetails)
        : false,
    };
  },

  toJSON(message: DiscoveryQuery): unknown {
    const obj: any = {};
    if (message.implementsRpc?.length) {
      obj.implementsRpc = message.implementsRpc;
    }
    if (message.appName !== "") {
      obj.appName = message.appName;
    }
    if (message.serviceName !== "") {
      obj.serviceName = message.serviceName;
    }
    if (message.location !== undefined) {
      obj.location = LocationQuery.toJSON(message.location);
    }
    if (message.includeExtendedMetadata === true) {
      obj.includeExtendedMetadata = message.includeExtendedMetadata;
    }
    if (message.includeSchemaDetails === true) {
      obj.includeSchemaDetails = message.includeSchemaDetails;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryQuery>, I>>(base?: I): DiscoveryQuery {
    return DiscoveryQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryQuery>, I>>(object: I): DiscoveryQuery {
    const message = createBaseDiscoveryQuery();
    message.implementsRpc = object.implementsRpc?.map((e) => e) || [];
    message.appName = object.appName ?? "";
    message.serviceName = object.serviceName ?? "";
    message.location = (object.location !== undefined && object.location !== null)
      ? LocationQuery.fromPartial(object.location)
      : undefined;
    message.includeExtendedMetadata = object.includeExtendedMetadata ?? false;
    message.includeSchemaDetails = object.includeSchemaDetails ?? false;
    return message;
  },
};

function createBaseLocationQuery(): LocationQuery {
  return { server: "", user: "", userServer: "" };
}

export const LocationQuery = {
  encode(message: LocationQuery, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.server !== "") {
      writer.uint32(10).string(message.server);
    }
    if (message.user !== "") {
      writer.uint32(18).string(message.user);
    }
    if (message.userServer !== "") {
      writer.uint32(26).string(message.userServer);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LocationQuery {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLocationQuery();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.server = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.user = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userServer = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LocationQuery {
    return {
      server: isSet(object.server) ? globalThis.String(object.server) : "",
      user: isSet(object.user) ? globalThis.String(object.user) : "",
      userServer: isSet(object.userServer) ? globalThis.String(object.userServer) : "",
    };
  },

  toJSON(message: LocationQuery): unknown {
    const obj: any = {};
    if (message.server !== "") {
      obj.server = message.server;
    }
    if (message.user !== "") {
      obj.user = message.user;
    }
    if (message.userServer !== "") {
      obj.userServer = message.userServer;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LocationQuery>, I>>(base?: I): LocationQuery {
    return LocationQuery.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LocationQuery>, I>>(object: I): LocationQuery {
    const message = createBaseLocationQuery();
    message.server = object.server ?? "";
    message.user = object.user ?? "";
    message.userServer = object.userServer ?? "";
    return message;
  },
};

function createBaseDiscoveryRequest(): DiscoveryRequest {
  return { requestId: "", replySuffix: "", timestamp: "0", query: undefined };
}

export const DiscoveryRequest = {
  encode(message: DiscoveryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.replySuffix !== "") {
      writer.uint32(18).string(message.replySuffix);
    }
    if (message.timestamp !== "0") {
      writer.uint32(24).int64(message.timestamp);
    }
    if (message.query !== undefined) {
      DiscoveryQuery.encode(message.query, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiscoveryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.replySuffix = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.timestamp = longToString(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.query = DiscoveryQuery.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveryRequest {
    return {
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : "",
      replySuffix: isSet(object.replySuffix) ? globalThis.String(object.replySuffix) : "",
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : "0",
      query: isSet(object.query) ? DiscoveryQuery.fromJSON(object.query) : undefined,
    };
  },

  toJSON(message: DiscoveryRequest): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.replySuffix !== "") {
      obj.replySuffix = message.replySuffix;
    }
    if (message.timestamp !== "0") {
      obj.timestamp = message.timestamp;
    }
    if (message.query !== undefined) {
      obj.query = DiscoveryQuery.toJSON(message.query);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveryRequest>, I>>(base?: I): DiscoveryRequest {
    return DiscoveryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveryRequest>, I>>(object: I): DiscoveryRequest {
    const message = createBaseDiscoveryRequest();
    message.requestId = object.requestId ?? "";
    message.replySuffix = object.replySuffix ?? "";
    message.timestamp = object.timestamp ?? "0";
    message.query = (object.query !== undefined && object.query !== null)
      ? DiscoveryQuery.fromPartial(object.query)
      : undefined;
    return message;
  },
};

function createBaseRpcListRequest(): RpcListRequest {
  return {};
}

export const RpcListRequest = {
  encode(_: RpcListRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcListRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RpcListRequest {
    return {};
  },

  toJSON(_: RpcListRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcListRequest>, I>>(base?: I): RpcListRequest {
    return RpcListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcListRequest>, I>>(_: I): RpcListRequest {
    const message = createBaseRpcListRequest();
    return message;
  },
};

function createBaseRpcInfo(): RpcInfo {
  return { name: "", methods: [], formats: [], description: "" };
}

export const RpcInfo = {
  encode(message: RpcInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    for (const v of message.methods) {
      writer.uint32(18).string(v!);
    }
    writer.uint32(26).fork();
    for (const v of message.formats) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.methods.push(reader.string());
          continue;
        case 3:
          if (tag === 24) {
            message.formats.push(reader.int32() as any);

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.formats.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcInfo {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      methods: globalThis.Array.isArray(object?.methods) ? object.methods.map((e: any) => globalThis.String(e)) : [],
      formats: globalThis.Array.isArray(object?.formats)
        ? object.formats.map((e: any) => serializationFormatFromJSON(e))
        : [],
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: RpcInfo): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.methods?.length) {
      obj.methods = message.methods;
    }
    if (message.formats?.length) {
      obj.formats = message.formats.map((e) => serializationFormatToJSON(e));
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcInfo>, I>>(base?: I): RpcInfo {
    return RpcInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcInfo>, I>>(object: I): RpcInfo {
    const message = createBaseRpcInfo();
    message.name = object.name ?? "";
    message.methods = object.methods?.map((e) => e) || [];
    message.formats = object.formats?.map((e) => e) || [];
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseRpcListResponse(): RpcListResponse {
  return { rpcs: [] };
}

export const RpcListResponse = {
  encode(message: RpcListResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.rpcs) {
      RpcInfo.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcListResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.rpcs.push(RpcInfo.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcListResponse {
    return { rpcs: globalThis.Array.isArray(object?.rpcs) ? object.rpcs.map((e: any) => RpcInfo.fromJSON(e)) : [] };
  },

  toJSON(message: RpcListResponse): unknown {
    const obj: any = {};
    if (message.rpcs?.length) {
      obj.rpcs = message.rpcs.map((e) => RpcInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcListResponse>, I>>(base?: I): RpcListResponse {
    return RpcListResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcListResponse>, I>>(object: I): RpcListResponse {
    const message = createBaseRpcListResponse();
    message.rpcs = object.rpcs?.map((e) => RpcInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRpcGetRequest(): RpcGetRequest {
  return { name: "", format: 0 };
}

export const RpcGetRequest = {
  encode(message: RpcGetRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.format !== 0) {
      writer.uint32(16).int32(message.format);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcGetRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.format = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcGetRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      format: isSet(object.format) ? rpcFormatFromJSON(object.format) : 0,
    };
  },

  toJSON(message: RpcGetRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.format !== 0) {
      obj.format = rpcFormatToJSON(message.format);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcGetRequest>, I>>(base?: I): RpcGetRequest {
    return RpcGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcGetRequest>, I>>(object: I): RpcGetRequest {
    const message = createBaseRpcGetRequest();
    message.name = object.name ?? "";
    message.format = object.format ?? 0;
    return message;
  },
};

function createBaseRpcGetResponse(): RpcGetResponse {
  return {
    name: "",
    format: 0,
    data: new Uint8Array(0),
    errorMessage: "",
    messageCount: 0,
    enumCount: 0,
    dependencies: [],
  };
}

export const RpcGetResponse = {
  encode(message: RpcGetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.format !== 0) {
      writer.uint32(16).int32(message.format);
    }
    if (message.data.length !== 0) {
      writer.uint32(26).bytes(message.data);
    }
    if (message.errorMessage !== "") {
      writer.uint32(34).string(message.errorMessage);
    }
    if (message.messageCount !== 0) {
      writer.uint32(40).int32(message.messageCount);
    }
    if (message.enumCount !== 0) {
      writer.uint32(48).int32(message.enumCount);
    }
    for (const v of message.dependencies) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RpcGetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRpcGetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.format = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.data = reader.bytes();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.messageCount = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.enumCount = reader.int32();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.dependencies.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RpcGetResponse {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      format: isSet(object.format) ? rpcFormatFromJSON(object.format) : 0,
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : "",
      messageCount: isSet(object.messageCount) ? globalThis.Number(object.messageCount) : 0,
      enumCount: isSet(object.enumCount) ? globalThis.Number(object.enumCount) : 0,
      dependencies: globalThis.Array.isArray(object?.dependencies)
        ? object.dependencies.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: RpcGetResponse): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.format !== 0) {
      obj.format = rpcFormatToJSON(message.format);
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.errorMessage !== "") {
      obj.errorMessage = message.errorMessage;
    }
    if (message.messageCount !== 0) {
      obj.messageCount = Math.round(message.messageCount);
    }
    if (message.enumCount !== 0) {
      obj.enumCount = Math.round(message.enumCount);
    }
    if (message.dependencies?.length) {
      obj.dependencies = message.dependencies;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RpcGetResponse>, I>>(base?: I): RpcGetResponse {
    return RpcGetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RpcGetResponse>, I>>(object: I): RpcGetResponse {
    const message = createBaseRpcGetResponse();
    message.name = object.name ?? "";
    message.format = object.format ?? 0;
    message.data = object.data ?? new Uint8Array(0);
    message.errorMessage = object.errorMessage ?? "";
    message.messageCount = object.messageCount ?? 0;
    message.enumCount = object.enumCount ?? 0;
    message.dependencies = object.dependencies?.map((e) => e) || [];
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if (globalThis.Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if (globalThis.Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToString(long: Long) {
  return long.toString();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
